module.exports = __webpack_public_path__ + "static/media/support_image.e05a6007.png";